module.exports = __webpack_public_path__ + "img/c03_buildingstartechcalltoarms_Normal_ua.384ef437.webp";